module.exports = __webpack_public_path__ + "static/img/pinpai-4.108554ab.png";